import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { isTablet } from "react-device-detect";
import { icon } from "../../common/common";
import { replaceAllData } from "../../common/commonJS";
import { ReceiverDetailsContext } from "../../contexts/receiverDetailsContext";
import { MessageData } from "../../models/messaging";

interface ChatReplyProps {
  senderID: string;
  backgroundColorClass: string;
  selectedReply: MessageData;
  onReplyMessageClick?: any;
  noPadding?: boolean;
}

const ChatReply = ({ senderID, backgroundColorClass, selectedReply, onReplyMessageClick, noPadding = false }: ChatReplyProps) => {
  const { receiverDetails } = useContext<any>(ReceiverDetailsContext);
  let messageValue: any = selectedReply.messageContent;
  if (selectedReply.messageType === 3) {
    try {
      messageValue = JSON.parse(selectedReply.messageContent);
    } catch (e) {
      messageValue = selectedReply.messageContent;
    }
  }
  if (selectedReply.messageType === 4) {
    try {
      messageValue = JSON.parse(selectedReply.messageContent).messageContent;
    } catch (e) {
      messageValue = selectedReply.messageContent.messageContent;
    }
  }
  if (selectedReply.messageType !== 3) {
    messageValue = replaceAllData(messageValue, `width="48"`, `width="22"`);
    messageValue = replaceAllData(messageValue, `width="36"`, `width="22"`);
    messageValue = replaceAllData(messageValue, `width="32"`, `width="22"`);
    messageValue = replaceAllData(messageValue, `width="24"`, `width="22"`);
    messageValue = replaceAllData(messageValue, `height="48"`, `height="20"`);
    messageValue = replaceAllData(messageValue, `height="36"`, `height="20"`);
    messageValue = replaceAllData(messageValue, `height="32"`, `height="20"`);
    messageValue = replaceAllData(messageValue, `height="24"`, `height="20"`);
  }

  return (
    <Box
      className={`${noPadding ? "w-per-100 cur-pot" : "chatReplyAnimation"} ht-64 ${backgroundColorClass} flex flex-direction-row align-items-center ${noPadding ? "border-radius-top" : "bor-t-r-b-l-4"} overflow-h`}
      sx={{ margin: noPadding ? "0px" : "8px 8px 4px 8px" }}
      onClick={onReplyMessageClick ? onReplyMessageClick : () => {}}
    >
      <Box className={`h-per-100 ${selectedReply.recipientUcnum !== senderID ? "bg-primary-color" : "bg-amethyst"}`} sx={{ width: "4px" }} />
      <Box className="h-per-100 flex flex-direction-column flex-grow pad-t-4 pad-b-4 pad-l-8 pad-r-8 justify-content-center" sx={{ width: "calc(100% - 4px)"}}>
        <Typography variant="caption" className={`${isTablet ? "ft-14" : ""} message-text-reply clamp-1 ft-wt-500 ${selectedReply.recipientUcnum !== senderID ? "text-primary-color" : "text-amethyst"}`}>
          {selectedReply.recipientUcnum !== senderID ? "You" : receiverDetails.name}
        </Typography>
        {selectedReply.messageType === 2 && !selectedReply.messageContent.includes("waving-hand.png") ? ( 
          icon({ iconName: "thumb_up", iconColor: "icon-safety-orange", iconSize: "size-32", iconCustomClass: "orange" })
        ) : selectedReply.messageType === 3 ? (
          <Typography variant="body2" component="div" className={`${isTablet ? "ft-16" : ""} flex text-secondary clamp-1 flex align-items-center`}>
            {icon({ iconName: "video_library", iconColor: "icon-secondary", iconSize: "size-16", iconCustomClass: "mar-r-4" })}
            Post
          </Typography>
        ) : (
          <div
            className={`display-block text-secondary clamp-2 ${isTablet ? "ft-16" : "ft-14"}`}
            style={{ whiteSpace: "pre-line", wordWrap: "break-word", width: "100%", lineHeight: "17px" }}
            dangerouslySetInnerHTML={{
              __html: messageValue,
            }}
          ></div>
        )}
      </Box>
      {selectedReply.messageType === 3 && (
        <Box className={`h-per-100`}>
          <img alt={messageValue.name} src={messageValue.postImage.replace("120", "64")} style={{ objectFit: "cover", objectPosition: "center", width: "64px", height: "64px" }} />
        </Box>
      )}
    </Box>
  );
};

export default ChatReply;
